import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useSearchParams } from "react-router-dom";
import { useUnosVideoGet } from "hooks/unos/video/useUnosVideoGet";
import VideoEdit from "./VideoEdit";
import VideoRead from "./VideoRead";

const VideoComponent = () => {
  const { videoId } = useParams();
  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState<string>("");
  const video = useUnosVideoGet(videoId as string);
  useEffect(() => {
    const paramsMode = searchParams.get("mode") ?? "";
    if (paramsMode !== mode) {
      setMode(paramsMode);
    }
  }, [searchParams]);

  if (!video) {
    return null;
  }

  return (
    <>
      {mode !== "edit" && <VideoRead video={video} />}
      {mode === "edit" && <VideoEdit video={video} />}
    </>
  );
};

export default VideoComponent;
